// Recovered compiled webpack factory 74841. Edit this function expression; run npm run build.
(e, t, r) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      default: function () {
        return m;
      },
      defaultHead: function () {
        return f;
      },
    }));
  let n = r(28140),
    i = r(49417),
    o = r(95155),
    a = i._(r(12115)),
    l = n._(r(1262)),
    s = r(90737),
    d = r(82073),
    u = r(60861);
  function f(e) {
    void 0 === e && (e = !1);
    let t = [(0, o.jsx)("meta", { charSet: "utf-8" }, "charset")];
    return (
      e ||
        t.push((0, o.jsx)("meta", { name: "viewport", content: "width=device-width" }, "viewport")),
      t
    );
  }
  function c(e, t) {
    return "string" == typeof t || "number" == typeof t
      ? e
      : t.type === a.default.Fragment
        ? e.concat(
            a.default.Children.toArray(t.props.children).reduce(
              (e, t) => ("string" == typeof t || "number" == typeof t ? e : e.concat(t)),
              [],
            ),
          )
        : e.concat(t);
  }
  r(94781);
  let p = ["name", "httpEquiv", "charSet", "itemProp"];
  function g(e, t) {
    let { inAmpMode: r } = t;
    return e
      .reduce(c, [])
      .reverse()
      .concat(f(r).reverse())
      .filter(
        (function () {
          let e = new Set(),
            t = new Set(),
            r = new Set(),
            n = {};
          return (i) => {
            let o = !0,
              a = !1;
            if (i.key && "number" != typeof i.key && i.key.indexOf("$") > 0) {
              a = !0;
              let t = i.key.slice(i.key.indexOf("$") + 1);
              e.has(t) ? (o = !1) : e.add(t);
            }
            switch (i.type) {
              case "title":
              case "base":
                t.has(i.type) ? (o = !1) : t.add(i.type);
                break;
              case "meta":
                for (let e = 0, t = p.length; e < t; e++) {
                  let t = p[e];
                  if (i.props.hasOwnProperty(t))
                    if ("charSet" === t) r.has(t) ? (o = !1) : r.add(t);
                    else {
                      let e = i.props[t],
                        r = n[t] || new Set();
                      ("name" !== t || !a) && r.has(e) ? (o = !1) : (r.add(e), (n[t] = r));
                    }
                }
            }
            return o;
          };
        })(),
      )
      .reverse()
      .map((e, t) => {
        let r = e.key || t;
        return a.default.cloneElement(e, { key: r });
      });
  }
  let m = function (e) {
    let { children: t } = e,
      r = (0, a.useContext)(s.AmpStateContext),
      n = (0, a.useContext)(d.HeadManagerContext);
    return (0, o.jsx)(l.default, {
      reduceComponentsToState: g,
      headManager: n,
      inAmpMode: (0, u.isInAmpMode)(r),
      children: t,
    });
  };
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
